import React, { useEffect } from 'react';
import styles from './Previews.module.css';

const Previews = () => {
  useEffect(() => {
    document.title = `Studio Lain | Plany wydawnicze`;
  }, []);
  return (
    <>
      <main className='container_page'>
        <h2 className='title'>Nasze plany wydawnicze</h2>
        <p className={styles.text_introduce}>
          <a
            href='https://komiksopedia.pl/aktualnosc/zapowiedzi-studia-lain-na-2026-r/'
            target='_blank'
            rel='noreferrer'
          >
            Przeczytaj artykuł: <b>Zapowiedzi Studia Lain na 2026 r.</b>
          </a>
        </p>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/solo.jpeg' alt='Solo'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Solo 5 & 6</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Tytył oryginalny</li>
              <li>
                Solo: <br /> 5. Marcher sans soulever de poussière, <br /> 6. La
                fin d'un cercle infini
              </li>
              <li>Scenariusz</li>
              <li>Oscar Martin</li>
              <li>Ilustracje</li>
              <li>Oscar Martin</li>
            </ul>

            <p>Postapokaliptyczny świat zwierzęcych klanów stoi na krawędzi wojny totalnej. Idee Legatusa, które miały przynieść nadzieję, rozchodzą się po wszystkich gatunkach i wywołują rewolucję. Gdy ludzie ruszają do krwawego ataku, a nowe frakcje walczą o władzę, nadchodzi finałowy konflikt, który na zawsze odmieni uniwersum Solo – brutalnej, ale poruszającej opowieści o przetrwaniu, lojalności i cenie wolności.</p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/BD-Solo-Martin-Tome-5-Marcher-sans-soulever-de-poussiere-414088.html'
                target='_blank'
                rel='noreferrer'
              >
                <p>
                  {' '}
                  <b> Link BD - Tom 5</b>
                </p>
              </a>
              <a
                href='https://www.bedetheque.com/BD-Solo-Martin-Tome-6-La-fin-d-un-cercle-infini-482593.html'
                target='_blank'
                rel='noreferrer'
              >
                <p>
                  <b> Link BD - Tom 6</b>
                </p>
              </a>
            </p>
          </div>
        </div>



        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/tagh.png'
              alt='Tagh'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Tagh</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Alfredo Grassi</li>
              <li>Ilustracje</li>
              <li>Juan Zanotto</li>
            </ul>
            <p>Na planecie Rogha, zwanej „światem wiatru”, od wieków trwa brutalny konflikt płci. Prymitywni mężczyźni żyją w obozach, traktując kobiety jak niewolnice, podczas gdy wysoko w górach rozkwita zaawansowana cywilizacja amazonek, przewyższających ich intelektem i techniką. W samym środku tej wojny Tagh, wojownik zmierzchu, oraz jego towarzyszka Fulvia wyruszają w podróż, która doprowadzi ich do granic znanego świata – i do odkrycia tajemnicy, zdolnej na zawsze odmienić los Roghi. </p>
          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/cronicas.webp'
              alt='Cronicas del Tiempo Medio'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Cronicas del Tiempo Medio</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Emilio Balcarce</li>
              <li>Ilustracje</li>
              <li>Juan Zanotto</li>
            </ul>

            <p>Po globalnej wojnie nuklearnej ludzkość wkracza w tak zwany „Czas Pośredni” – epokę chaosu i ciemności, w której na ruinach cywilizacji o władzę nad Ziemią walczą dwie potężne inteligencje: zimna, bezlitosna sztuczna świadomość Nerón oraz mutujący nadczłowiek Brain. Ludzie, maszyny i zmutowane istoty stają się pionkami w ich gigantycznej partii szachów, rozgrywanej na tle radioaktywnych pustkowi. </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-51830-BD-Cronache-del-tempo-medio.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>



          </div>
        </div>



        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/5-por-infinito.jpg'
              alt='5 por infinito'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>5 por infinito</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Esteban Maroto</li>
              <li>Ilustracje</li>
              <li>Esteban Maroto</li>
            </ul>

            <p>Klasyka europejskiego sci-fi. Piątka ziemskich bohaterów – astrofizyk Altar, parapsycholożka Aline, gwiazda filmowa Hydra, kaskader Sirius i olbrzymi ochroniarz Orion – jako grupa „5 por Infinito” przemierza kosmos, by ratować zagrożone cywilizacje i stawiać czoła tajemniczym zjawiskom na odległych planetach. Esteban Maroto łączy tu psychodeliczny klimat epoki, space operę i odważną, dekoracyjną kreskę, która uczyniła serię jednym z najbardziej cenionych hiszpańskich komiksów science fiction </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/BD-5-por-infinito-INT-5-por-Infinito-438076.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>

          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/first-kingdom.png'
              alt='The first Kingdom'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>The First Kingdom</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Jack Katz</li>
              <li>Ilustracje</li>
              <li>Jack Katz</li>
            </ul>

            <p>Monumentalna, autorska saga sci-fi/fantasy, nad którą Jack Katz pracował dwanaście lat. Po nuklearnej zagładzie ludzkość cofa się do epoki plemion i barbarzyńców, a na zgliszczach cywilizacji rodzą się nowe mity, bogowie i królestwa. W centrum tej epopei stoją Darkenmoor i jego syn Tundran, którzy próbują wyrwać swój lud z prymitywnego świata polowań i niewolnictwa – nieświadomi, że nad ich losem pochyla się całe zgromadzenie kapryśnych bogów. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-63759-BD-First-Kingdom-1974.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>

          </div>
        </div>




        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/nevada.jpg'
              alt='Nevada'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Nevada</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Fred Duval, Jean-Pierre Pécau</li>
              <li>Ilustracje</li>
              <li>Colin Wilson</li>
            </ul>
            <p>To stylowy neo-western osadzony w latach 20. XX wieku, w epoce kiedy Dziki Zachód przeniósł się już z preriowych szlaków na plan filmowy rodzącego się Hollywood. Głównym bohaterem jest Nevada Marquez – były awanturnik i „fixer” zatrudniany przez wytwórnie jako człowiek od zadań specjalnych. Jego robota? Załatwiać kłopoty, których wielkie studia nie chcą widzieć w gazetach: wyciągać gwiazdy z tarapatów, odzyskiwać zaplątanych w nałogi lub afery aktorów, a przy okazji mierzyć się z przestępczym półświatkiem na styku Kalifornii, pogranicza amerykańsko-meksykańskiego i tytułowej Nevady.</p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-65630-BD-Nevada-Duval-Pecau-Wilson.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>

          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/la-saison-de-la-couloeuvre.jpg'
              alt='La saison de la Coulœuvre'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>La saison de la Coulœuvre</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Serge Lehman</li>
              <li>Ilustracje</li>
              <li>Jean-Marie Michaud</li>
            </ul>
            <p>Epicka space opera z ambicjami filozoficznymi. W odległej przyszłości ludzie władają Drogą Mleczną dzięki sieci kosmicznych wrót zwanych „toboganami”, zbudowanych dawno temu przez legendarny lud Mohais. Kiedy w jednym z węzłów – Intersection 55 – dochodzi do tajemniczej „awarii” sieci, młodzi urzędnicy Rhéa Davenham i Derec Finn oraz garstka międzygwiezdnych podróżników stają się świadkami zjawiska, które wygląda jednocześnie na techniczną katastrofę… i powrót zapomnianego bóstwa.</p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-16372-BD-Saison-de-la-Couloeuvre.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>

          </div>
        </div>



        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/vanish.jpg'
              alt='Vanish'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Vanish</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Donny Cates</li>
              <li>Ilustracje</li>
              <li>Ryan Stegman</li>
            </ul>
            <p>Vanish to brutalna mieszanka mrocznej urban fantasy i superbohaterskiego klimatu od duetu Donny Cates (scenariusz) i Ryan Stegman (rysunki), znanego z Venoma.
              Bohaterem serii jest Oliver Harrison, który jako 14-latek uratował magiczną krainę Everkeep przed tyranem zwanym Baron Vanish. Lata później to wrak człowieka, topiący traumy w używkach. Gdy w jego mieście pojawia się błyszcząca drużyna superbohaterów Prestige, Oliver rozpoznaje w nich dawnych wrogów w nowych kostiumach… i wraca na drogę przemocy, by dokończyć to, co zaczęto w świecie magii. To komiks o zemście, uzależnieniach i cienkiej granicy między bohaterem a potworem.
            </p><p>2026/Image comics
            </p>

          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/nocterra.jpg'
              alt='Nocterra'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Nocterra</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Scott Snyder</li>
              <li>Ilustracje</li>
              <li>Tony S. Daniel</li>
            </ul>
            <p>
              Nocterra to wysokooktanowe postapo z twistem SF: dziesięć lat po „Wielkim Zmierzchu”, który pogrążył Ziemię w wiecznej nocy, każdy organizm pozostawiony w ciemności mutuje w potworne Shades. Jedynym ratunkiem jest światło. Valentina „Val” Riggs przewozi ludzi i ładunki między ostatnimi, skąpanymi w blasku enklawami, ścigana przez bestie i jeszcze gorszych ludzi. To mroczna, pędząca jak tir mieszanka survivalu, road-movie i potworów z cienia.
              2026/Image Comics
              Autorzy i atuty serii
              — Scott Snyder (scenariusz) — jeden z najbardziej rozpoznawalnych autorów mainstreamu i komiksu autorskiego: współtwórca American Vampire, wieloletni architekt Batmana (m.in. „Court of Owls”, „Death of the Family”), współautor eventów Dark Nights: Metal/Death Metal, a w Image znany też z Wytches i Undiscovered Country. Wielokrotnie notowany na listach bestsellerów „NYT”.
              — Tony S. Daniel (rysunki) — gwiazda rysunku superbohaterskiego: Batman, Detective Comics, Deathstroke; w Image współtwórca kultowego The Tenth.

            </p><p>2026/Image comics
            </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-77786-BD-Nocterra.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>



          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/skinbreaker.jpg'
              alt='Skinbreaker'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Skinbreaker</h1>
            <p>Nowa brutalna epopeja fantasy twórcy The Walking Dead i Invincible. W odległym, obcym świecie stary wódz orków Enor traci siły – a wraz z nimi kontrolę nad plemieniem. Jedyną nadzieją na przetrwanie jest jego niechętny spadkobierca Anok i przekazywany z pokolenia na pokolenie, legendarny topór Skinbreaker. Gdy na horyzoncie pojawia się jeszcze większe zagrożenie niż wewnętrzna walka o władzę, rozpoczyna się krwawa gra o sukcesję, honor i samo istnienie klanu. </p>
          </div>
        </div>



        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/monster-kill-squad.jpg'
              alt='Monster Kill Squad'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Monster Kill Squad</h1>
            <p>Kiedyś potwory były tylko miejskimi legendami. Dziś ataki wiedźm, demonów, klaunów-zabójców i duchów to codzienność, a Amerykanie mają tego serdecznie dość. Do akcji wkracza Monster Kill Squad – tajna, rządowa jednostka złożona z najbardziej niebezpiecznych speców na planecie, uzbrojonych po zęby i gotowych odstrzelić łeb wszystkiemu, co wyszło z koszmaru. Dynamiczna, krwawa mieszanka militarnej akcji, horroru i czarnego humoru.</p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/hellcop.jpg' alt='Hellcop'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Hellcop</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Brian Haberlin</li>
              <li>Ilustracje</li>
              <li>Brian Haberlin, Geirrod van Dyke</li>
            </ul>

            <p>Kiedy ludzkość po raz pierwszy przebiła się przez ściany między wymiarami, odkryła Known Reality Plane 1301-A – dosłownie Piekło. Aby pilnować, by żadne z jego potworów nie przedostało się na Ziemię, powołano Pan-Dimensional Security Corps, znane jako Hellcops. To futurystyczni „policjanci od piekła”, patrolujący piekielną rzeczywistość, rozbijający przemyt demonów i badający spiski, które mogą zniszczyć oba światy. Mroczne połączenie kryminału, science fiction i urban fantasy. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://imagecomics.com/comics/series/hellcop'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link imagecomics.com</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/cyberforce.jpg' alt='Cyberforce'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Cyberforce</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Marc Silvestri</li>
              <li>Ilustracje</li>
              <li>Marc Silvestri</li>
            </ul>

            <p>
              W skład albumu wejdzie: CYBERFORCE #0, CYBERFORCE THE TIN MEN OF
              WAR #1-4, THE KILLER INSTINCT CROSSOVER WITH WILDCATS #5-7,
              CYBERFORCE VOLUME 2 #1-13, CYBERFORCE ORIGINS: #1 CYBLADE,
              CYBERFORCE ORIGINS #2 STRYKER and the CYBERFORCE ANNUAL #1
            </p>


          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/miraze.png' alt='Mirages'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Miraże rozszerzonej nadrzeczywistości</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Tytył oryginalny</li>
              <li>Mirages et folies augmentées</li>
              <li>Scenariusz</li>
              <li>Philippe Druillet</li>
              <li>Ilustracje</li>
              <li>Philippe Druillet</li>
            </ul>

            <p>Imponujący, ponad 350-stronicowy album, w którym Philippe Druillet wyciąga z cienia swoje „zaginione” skarby: opowieści z Pilote, Métal Hurlant, L’Écho des Savanes, (À suivre), wczesne eksperymenty graficzne i komiksy tworzone we współpracy z takimi nazwiskami jak Jacques Lob, Alexis, Gotlib czy Jean-Pierre Dionnet. </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.glenat.com/hors-collection-glenat-bd/mirages-et-folies-augmentees-9782344037997'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link Glenat</b>
              </a>
            </p>
          </div>
        </div>





        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/colder.jpeg'
              alt='Colder'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Colder</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Paul Tobin</li>
              <li>Ilustracje</li>
              <li>Juan E. Ferreyra</li>
            </ul>

            <p>Declan Thomas jest zimny. Dosłownie. Jako były pacjent spalonego zakładu dla obłąkanych nigdy nie choruje, nie czuje bólu, a jego temperatura ciała wciąż spada. Ma jednak dar: potrafi wchodzić do szaleństwa innych ludzi i czasem je leczyć. Każda taka wyprawa sprawia, że sam staje się… jeszcze zimniejszy. Gdy do jego życia wraca demoniczny żartowniś Nimble Jack, karmiący się obłędem jak delicją, Boston zamienia się w koszmar, a Declan musi zdecydować, ilu jeszcze ludzi zdoła uratować, zanim jego temperatura spadnie do zera. </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/BD-Colder-INT-469414.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/crossed.jpg'
              alt='Colder'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Crossed i Crossed 100+</h1>


            <p>Świat po „Zaskoczeniu” – pandemii, która nie zamienia ludzi w zombie, ale w świadomych, inteligentnych seryjnych morderców z krwawym krzyżem na twarzy. Crossed tomy 1–3 pokazują pierwsze, najbrutalniejsze lata po wybuchu zarazy: wędrówkę ocalałych przez USA, rozpad „idealnej” religijnej rodziny i polowanie na psychopatycznego super-Crossed. Crossed +100 przenosi akcję sto lat później – Alan Moore opowiada o ludzkości, która próbuje odbudować cywilizację, nie wiedząc, że Crossed szykują powrót. Cała, zamknięta oś czasu serii w jednym pakiecie – tylko dla bardzo odpornych czytelników. </p>
            <p>
              Więcej informacji na temat zagranicznych wydań:
              <p><a
                href='https://www.bedetheque.com/serie-27352-BD-Crossed.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD: Crossed</b>
              </a></p>

              <p><a
                href='https://www.bedetheque.com/serie-49406-BD-Crossed-100.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD: Crossed + 100</b>
              </a>
              </p>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/quetzalcoatl.jpg'
              alt='Quetzalcoatl'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Quetzalcoatl</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Jean-Yves Mitton</li>
              <li>Ilustracje</li>
              <li>Jean-Yves Mitton</li>
            </ul>

            <p>1525 rok. Młoda Indianka Maiana „Dwie Kwiaty Kukurydzy” tuż przed egzekucją wyznaje swoją historię księdzu Enrico Segru. Pięć lat wcześniej cudem uniknęła azteckiej ofiary z ludzi, która pochłonęła życie jej narzeczonego. Po latach niewoli i zdrad stanie się kolejną kochanką cesarza Montezumy, a potem „oficjalną kurtyzaną” konkwistadora Hernána Cortésa. Jej tragiczny los splata się z upadkiem imperium Azteków oraz mitem o Quetzalcoatlu – Pierzastym Wężu. Historyczna seria Mittona bez litości obnażająca okrucieństwo podboju Nowego Świata. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-1119-BD-Quetzalcoatl.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/zenith.jpg' alt='Zenith'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Zenith</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Grant Morrison </li>
              <li>Ilustracje</li>
              <li>Steve Yewell</li>
            </ul>

            <p>Brytyjski superbohater na miarę epoki MTV. Zenith – naprawdę Robert McDowell – jest jedynym aktywnym „supkiem” na świecie… i kompletnie go to nie obchodzi. Zamiast ratować ludzkość, woli karierę pop-gwiazdy, reklamy i imprezy. Problem w tym, że do gry wracają kosmiczne monstra Lloigor, naziści z Kultu Czarnego Słońca i zapomniani herosi lat 60. Seria Granta Morrisona i Steve’a Yeowella to bezlitosna, błyskotliwa dekonstrukcja superbohatera, satyra i jednocześnie dynamiczna, pełnokrwista opowieść akcji. </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://shop.2000ad.com/catalogue/graphic-novels/zenith'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link 2000 AD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/nemesis-the-warlock.jpg'
              alt='Nemesis The Warlock'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Nemesis The Warlock</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Pat Mills</li>
              <li>Ilustracje</li>
              <li>Jesus Redondo i Kevin O’Neill</li>
            </ul>

            <p>Tysiące lat w przyszłość. Ziemia, teraz zwana Termight, jest radioaktywnym wrakiem, a ludzkość żyje stłoczona w podziemnych tunelach, pod rządami fanatycznego dyktatora Torquemady i jego zakonu Terminatorów, którzy chcą „oczyścić” galaktykę z każdego obcego. Przeciw Imperium staje Nemesis – demoniczny, ognisty obcy czarnoksiężnik, wyznawca Khaosu i przywódca ruchu oporu Credo. Seria Pata Millsa to brutalna, przewrotna space fantasy – przypowieść o fanatyzmie, rasizmie i wojnie totalnej, podana w szalonym, psychodelicznym anturażu 2000 AD. </p>

            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://shop.2000ad.com/catalogue/graphic-novels/nemesis-the-warlock'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link 2000 AD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/sinister-dexter.jpg'
              alt='Sinister Dexter'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Sinister Dexter</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Dan Abnett</li>
              <li>Ilustracje</li>
              <li>Simon Davis</li>
            </ul>


            <p>Miasto Downlode rozlane po Europie jak ofiara wypadku – betonowa dżungla pełna gangów, skorumpowanych polityków i ludzi, których życie jest warte mniej niż kula. W tym świecie królują „gunsharks” – zawodowi zabójcy do wynajęcia. Dwaj najlepsi z nich, Finnigan Sinister i Ramone Dexter, biorą każdy kontrakt, byle dobrze płacił. Seria Dana Abnetta z rysunkami Simona Davisa to futurystyczny kryminał z dwójką antybohaterów, mieszanka czarnego humoru, gangsterskiej akcji i brutalnego SF w stylu 2000 AD. </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/fathom.jpg' alt='Fathom'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Fathom</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Michael Turner</li>
              <li>Ilustracje</li>
              <li>Michael Turner</li>
            </ul>
            <p>
              Aspen Matthews – była pływaczka olimpijska i biolog morska – całe życie czuła, że bardziej należy do oceanu niż do lądu. Jako dziecko została znaleziona na statku pasażerskim, bez pamięci o swojej przeszłości. Lata później, podczas pracy w podwodnym ośrodku badawczym, odkrywa prawdę: jest członkinią tajemniczej rasy Blue, wodnych humanoidów potrafiących kontrolować wodę i energię głębin. „Fathom” to flagowa seria Michaela Turnera – efektowne połączenie superbohaterskiego komiksu, science fiction i morskiej fantasy, w której stawką jest równowaga między światem ludzi a cywilizacją żyjącą „pod powierzchnią”.
            </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-69662-BD-Fathom-1998.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/witchblade.png' alt='Witchblade'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Witchblade</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Michael Turner, David Wohl, Brian Haberlin, Christina Z</li>
              <li>Ilustracje</li>
              <li>Michael Turner</li>
            </ul>
            <p>Nowy Jork, lata 90. Policjantka z wydziału zabójstw Sara Pezzini podczas nieudanej akcji wpada w sam środek starożytnej wojny o mistyczny artefakt – Witchblade, świadome, żyjące ostrze, które wybiera kobiecą nosicielkę i daje jej niewyobrażalną moc… ale za ogromną cenę. Od tej chwili Sara musi ścigać mafiosów, korporacyjnych psychopatów i demony, jednocześnie walcząc z samym artefaktem, który coraz mocniej wdziera się w jej życie. Klasyczna seria Top Cow, współtworzona m.in. przez Michaela Turnera, Davida Wohla, Briana Haber­lina i Christinę Z, to kwintesencja nadnaturalnego thrillera superbohaterskiego lat 90. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-69829-BD-Witchblade-Collected-Editions-1996.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/rising-stars.png'
              alt='Rising Stars'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Rising Stars</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Joe Michael Straczynski</li>
              <li>Ilustracje</li>
              <li>Christian Zanier, Brent Anderson</li>
            </ul>
            <p>
              W małym miasteczku Pederson spada tajemniczy meteor. Dwadzieścioro trójka dzieci poczętych w tym samym czasie zostaje na zawsze odmienionych – wyrastają na tzw. Specials, ludzi obdarzonych niezwykłymi mocami. Gdy dorastają, świat zaczyna ich wykorzystywać, bać się ich… i próbować ich kontrolować. „Rising Stars” to zamknięta, wielotomowa saga superbohaterska J. Michaela Straczynskiego – opowieść o tym, co naprawdę stałoby się, gdyby superludzie pojawili się w naszym świecie.
            </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-3328-BD-Rising-Stars-Semic.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/wraithborn.png'
              alt='Wraithborn'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Wraithborn</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Marcia Chen</li>
              <li>Ilustracje</li>
              <li>Joe Benitez</li>
            </ul>
            <p>On był szkolony od dziecka, żeby przejąć mistyczną moc.</p>
            <p>Ona jest nieśmiałą nastolatką, która dostaje ją przez przypadek.</p>
            Podczas nocnej walki ciężko ranny wojownik Wraithborn przekazuje swoją moc zwykłej licealistce Melanie Moore. Od tej chwili Melanie staje się jedyną bronią przeciw Nieśmiertelnym – pradawnym bogom, demonom i istotom z legend, które mogą opętywać ludzi i szykują powrót do władzy nad światem. „Wraithborn” to mroczne urban fantasy w klimacie lat 2000, łączące folklor z dynamiczną, bardzo efektowną kreską Joe Beniteza.
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-55113-BD-Wraithborn.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/violator.jpg'
              alt='Violator'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Violator</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Alan Moore</li>
            </ul>

            <p>Demon Violator zalicza najgorszy dzień w swoim nie-życiu.</p>
            <p>Pozbawiony mocy, ścigany przez własnych sadystycznych braci – Vacillatora, Vindicatora, Vandalizera i Vaporizera – oraz wynajętego przez mafię superzabójcę Admonishera, musi po raz pierwszy w historii uciekać, zamiast terroryzować innych. Sześciozeszytowa mini-seria „Violator: Origin” pokazuje demona od czasów, gdy był istotą niebieską w niebiosach, przez upadek do Piekła i wieki manipulowania ludzką historią – od starożytności, przez plagi i wojny, aż po czasy Spawna. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-52471-BD-Violator-1994.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/curse-of-the-spawn.jpg'
              alt='Curse of Spawn'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Curse of the Spawn</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Alan McElroy</li>
              <li>Ilustracje</li>
              <li>Dwayne Turner</li>
            </ul>

            <p>Spin-off Spawna, który przenosi akcję w przyszłość, prosto w sam środek postapokaliptycznego Armagedonu. Nowym Hellspawnem zostaje Daniel Llanso – człowiek z piekielnie ciężką przeszłością, który po śmierci wraca na Ziemię jako żołnierz Piekła. Ma zostać generałem armii demonów, ale zamiast tego próbuje ocalić swoją siostrę Madrid i jej syna Matta przed Nekro-żołnierzami, Anti-Papieżem i demonem Abaddonem. Seria rozwija mitologię uniwersum Spawna, pokazując inne Pomioty oraz losy postaci pobocznych znanych z głównego cyklu. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-24075-BD-Curse-of-the-Spawn-1996.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link BD</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/spawn-compedium.jpg'
              alt='Spawn Compedium'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Spawn 1-100 (4 tomy)</h1>
            <p>Sto pierwszych zeszytów Spawna w jednym pakiecie – komplet klasycznych historii od narodzin Ala Simmonsa jako piekielnego wojownika, przez jego wojny z mafią, Maleboglią, aniołami i innymi Hellspawnami, aż po duże przebudowanie status quo serii. To pełna „złota era” Todda McFarlane’a i Grega Capullo: mroczny, brutalny superhero-horror, który zdefiniował wizerunek Image Comics lat 90. i stał się jednym z najdłużej ukazujących się niezależnych tytułów w USA. </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/lhorloge.jpeg' alt='Lhorloge'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>L'horloge</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>José Roosevelt</li>
              <li>Ilustracje</li>
              <li>José Roosevelt</li>
            </ul>

            <p>Surrealistyczna, poetycka opowieść rozgrywająca się w świecie rządzonym przez znaki i symbole. Dwunastoczęściowa „godzina” składająca się z 12 rozdziałów/obrazów prowadzi bohaterów przez tajemnicze miasta, sekretną lożę, gigantyczne muszle unoszące się po niebie i labirynt ksiąg. „L’horloge” to pierwsza wielka BD José Roosevelta – malarska, symboliczna podróż, w której od czytelnika oczekuje się czegoś więcej niż tylko śledzenia fabuły </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img src='./img/zapowiedzi/brigada-3.jpg' alt='Brygada'></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Brygada 3</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Tytył oryginalny</li>
              <li>Brigada 3</li>
              <li>Scenariusz</li>
              <li>Enrique Fernandez</li>
              <li>Ilustracje</li>
              <li>Enrique Fernandez</li>
            </ul>

            <p>Finał baśniowej trylogii „Brigada”. Rozbita, skłócona brygada skazańców kapitana Ivro błądzi w obłąkanej mgle łączącej światy. Jeśli chcą wrócić do domu, muszą na nowo zaufać sobie nawzajem i stawić czoła chaosowi, który pochłania całe krainy. W trzecim tomie Enrique Fernández domyka wszystkie wątki – z rozmachem fantasy i ilustracjami, które wyglądają jak ruchome obrazy.</p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/BD-Brigada-en-espagnol-Tome-3-420694.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link</b>
              </a>
            </p>
          </div>
        </div>

        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/cyberfrog.jpg'
              alt='cyberfrog'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Cyberfrog</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Ethan Van Sciver</li>
              <li>Ilustracje</li>
              <li>Ethan Van Sciver</li>
            </ul>

            <p>Cybernetyczna, uzbrojona po zęby żaba z kosmosu kontra inwazja obcych szerszeni.
              Cyberfrog zostaje wysłany na Ziemię w żywym statku z planety Pyrdani, by powstrzymać nadciągającą plagę VYZPZZ – roju morderczych, niemal nie do zatrzymania owadów. Gdy inwazja uderza w 1998 roku, świat pogrąża się w chaosie, a Cyberfrog po latach budzi się w postapokaliptycznej rzeczywistości, gdzie ludzkość żyje w strachu, a ulice należą do szerszeni. Razem z olbrzymim, pancernym bratem Salamandroidem i swoją ludzką przyjaciółką Heather Swain musi spróbować ocalić to, co zostało z planety. Ten potężny integral łączy klasyczne historie z lat 90. („Warts and All”) z nową, widowiskową sagą „Bloodhoney” i „Rekt Planet” – kompletną, ponad 700-stronicową dawką brutalnego superhero SF. </p>

          </div>
        </div>


        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/sam-and-twitch.jpg'
              alt='sam and twitch'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Sam and Twitch</h1>

            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Brian Michael Bendis</li>
              <li>Ilustracje</li>
              <li>Angel Medina</li>
            </ul>

            <p>Dwóch najbardziej niepozornych gliniarzy z uniwersum Spawna we własnej serii i natychmiast lądują w samym środku najbrudniejszych spraw Nowego Jorku.</p><p>
              Sam Burke i Max „Twitch” Williams to staroświeccy detektywi w świecie pełnym skorumpowanych policjantów, religijnych fanatyków, seryjnych morderców i mafii. Historie  to mroczny kryminał noir z elementami horroru w duchu „Se7en”.</p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-26660-BD-Sam-and-Twitch-1999.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link</b>
              </a>
            </p>
          </div>
        </div>




        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/scorched.jpg'
              alt='scorched'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Scorched TPB 1-4</h1>

            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Todd McFarlane, Sean Lewis, John Layman</li>
              <li>Ilustracje (m.in.)</li>
              <li>Stephen Segovia, Paulo Siqueira, Dexter Soy, Von Randal</li>
            </ul>
            <p>
              Nowa drużyna z uniwersum Spawna.</p>
            <p>She-Spawn, Redeemer, Gunslinger Spawn, Medieval Spawn, Reaper i inni łączą siły jako The Scorched, żeby walczyć z zagrożeniami, z którymi nie poradzi sobie żaden samotny Hellspawn. W tomach 1–4 śledzimy narodziny drużyny, walkę z demonicznymi Sin Devourers, wewnętrzną zdradę, konflikt ze Spawnem oraz starcie z Jeźdźcami i kosmicznymi „Pożeraczami Planet”. To cztery dynamiczne, pełne akcji albumy grupowe, które rozbudowują całe Spawn Universe. </p>

          </div>
        </div>






        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/drifter.png'
              alt='Drifter'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Drifter</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Scenariusz</li>
              <li>Ivan Brandon</li>
              <li>Ilustracje</li>
              <li>Nic Klein</li>
            </ul>
            <p>Drifter to zamknięta, czterotomowa opowieść science-fiction (19 zeszytów, 2014–2017), w której rozbity pilot trafia na dziką, nieprzyjazną planetę i do kolonii rządzącej się prawem pogranicza. Zamiast prostych odpowiedzi dostajemy brudny, hipnotyczny space-western: tajemnica pamięci, wina i tożsamość ścierają się z codziennym przetrwaniem, a sam świat przedstawiony urasta do rangi bohatera.
              Autorski duet nadaje serii wyraz nie do podrobienia. Ivan Brandon (scenarzysta m.in. Viking i Black Cloud dla Image; pracował też dla Marvela i DC) prowadzi historię oszczędnie, budując napięcie poprzez niedopowiedzenia i ścierające się punkty widzenia. Nic Klein – rysownik i malarz (Image: Viking; Marvel: Thor, Winter Soldier, Deadpool) – tworzy obłędnie nastrojowe plansze: chropawe pejzaże, monumentalne kadry i intensywną, „malarską” kolorystykę, która niemal pachnie pyłem na wietrze.
            </p><p>2026/Image Comics
            </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://www.bedetheque.com/serie-46940-BD-Drifter.html'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link</b>
              </a>
            </p>
          </div>
        </div>



        <div className={styles.comics_preview}>
          <div className={styles.comics_preview_img}>
            <img
              src='./img/zapowiedzi/planet-death.png'
              alt='PLANET DEATH'
            ></img>
          </div>
          <div className={styles.comics_preview_info}>
            <h1 className={styles.title}>Planeta śmierci</h1>
            <ul className={`${styles.comics_data} ${styles.main_info}`}>
              <li>Tytuł oryginalny</li>
              <li>Planet Death</li>
              <li>Scenariusz</li>
              <li>Robert Venditti, Derek Kolstad</li>
              <li>Ilustracje</li>
              <li>Tomás Giorello</li>
            </ul>
            <p>Miliony kilometrów od Ziemi setki okrętów bojowych wchodzą w burzliwą atmosferę lodowej planety. Misja jest prosta: znaleźć broń zdolną zabić całą Ziemię i zniszczyć ją, zanim zrobi to ktoś inny. Lądowanie kończy się rzezią – z całej armii przy życiu zostaje tylko żołnierz w pancerzu bojowym, Scott. Odcięty od wsparcia, w samym środku wrogiego świata, musi przejść za linię frontu, przetrwać morderczy klimat, dezerterów i obce potwory… i samotnie dokończyć misję, z którą nie poradziła sobie cała inwazja.
              Kosmiczna wojna totalna od scenarzysty „John Wicka” Dereka Kolstada i Roberta Vendittiego („X-O Manowar”) z monumentalnymi rysunkami Tomása Giorello. </p>
            <p>
              Więcej informacji na temat zagranicznego wydania:
              <a
                href='https://mailchi.mp/badideacorp/planet-death-0-launches-today'
                target='_blank'
                rel='noreferrer'
              >
                <b> Link</b>
              </a>
            </p>
          </div>
        </div>


      </main>
    </>
  );
};

export default Previews;
